import { jsx as _jsx } from "react/jsx-runtime";
import FormLabel from "@mui/material/FormLabel";
import InputLabel from "@mui/material/InputLabel";
import { useCsAttribute } from "@plansoft-configuration-renderer/framework";
import { useAttributeDisplayOptions } from "../layouts/AttributeLayoutContext";
/**
 *
 * @param attribute Helper function for getting the label id for an attribute
 * @returns
 */
export function getAttributeLabelId(attribute) {
    return `label-for-${attribute.path}`;
}
/**
 * Helper to display shared options for controls
 * - id for label node
 * - display text for attribute name
 * - InputLabel node
 * - FormLabel node
 * @returns
 */
export function useAttributeInlineLabel() {
    var _a;
    const attribute = useCsAttribute();
    const { inlineLabel } = useAttributeDisplayOptions();
    if (!inlineLabel) {
        return {};
    }
    const labelId = getAttributeLabelId(attribute);
    const labelText = (_a = attribute.name) !== null && _a !== void 0 ? _a : attribute.id;
    return {
        labelId,
        labelText,
        inputLabel: (_jsx(InputLabel, { id: labelId, required: attribute.isRequired, children: labelText })),
        formLabel: (_jsx(FormLabel, { id: labelId, component: "legend", required: attribute.isRequired, children: labelText })),
    };
}
//# sourceMappingURL=useAttributeInlineLabel.js.map